var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourierDelivery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 76,
    viewBox: "0 0 57 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 60.2421C2 57.3376 2.4586 51.0701 4.29299 49.2357C6.58599 46.9427 15.758 44.1911 18.051 44.1911C20.3439 44.1911 22.1783 48.3185 28.5987 48.3185",
    stroke: "#1F7057",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7383 60.2421C54.7383 57.3376 54.2797 51.0701 52.4453 49.2357C50.1523 46.9427 40.9803 44.1911 38.6873 44.1911C36.3943 44.1911 34.5599 48.3185 28.1396 48.3185",
    stroke: "#1F7057",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1719 70.3312V63.9108L15.7579 54.2803H43.2738L48.3184 63.9108V70.3312",
    stroke: "#1F7057",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1719 63.9108H48.3184",
    stroke: "#1F7057",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3055 54.2803L24.9297 63.9108V73.0828L29.5157 70.3312L34.5603 74V63.9108L32.7259 54.2803",
    stroke: "#1F7057",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5987 2C24.0128 2 17.1338 6.12739 16.2166 9.79618C15.4828 12.7312 15.2994 18.6624 15.2994 21.2611L18.051 25.8471C19.2739 24.3185 23.0956 21.2611 28.5987 21.2611M13.465 25.8471C13.3121 27.8344 13.8319 31.7172 17.1338 31.3503C17.4395 35.0191 20.1604 42.3567 28.5987 42.3567",
    stroke: "#1F7057",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1395 2C32.7255 2 39.6045 6.12739 40.5217 9.79618C41.2555 12.7312 41.4389 18.6624 41.4389 21.2611L38.6873 25.8471C37.4644 24.3185 33.6427 21.2611 28.1395 21.2611M43.2733 25.8471C43.4262 27.8344 42.9064 31.7172 39.6045 31.3503C39.2988 35.0191 36.5779 42.3567 28.1395 42.3567",
    stroke: "#1F7057",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2988 18.9681C16.9804 16.9809 21.9944 13.0063 28.5982 13.0063C35.202 13.0063 39.9103 16.6751 41.439 18.5095",
    stroke: "#1F7057",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourierDelivery);
export default __webpack_public_path__ + "static/media/courier-delivery.89d84a789d181b2aa7ccac48c759d730.svg";
export { ForwardRef as ReactComponent };